import { Action, createReducer, on } from "@ngrx/store";
import * as teacherMetricsActions from "../actions/teacher-metrics.action";

import {User} from "cli-types";

export interface TeacherMetricsState {
    teacherMetrics: User | null;
    loading: boolean;
    loaded: boolean;
}

export const initialState: TeacherMetricsState = {
    teacherMetrics: null,
    loading: false,
    loaded: false,
};
const teacherMetricsReducer = createReducer(
    initialState,
    on(teacherMetricsActions.loadTeacherMetrics, (state, { payload }) => {
        return {
            ...state,
            loading: true,
        };
    }),
    on(
        teacherMetricsActions.loadTeacherMetricsSuccess,
        (state, { payload }) => {
            return {
                ...state,
                loading: false,
                loaded: true,
                teacherMetrics: payload,
            };
        }
    ),
    on(teacherMetricsActions.loadTeacherMetricsFail, (state, { payload }) => {
        return {
            ...state,
            loaded: false,
            loading: false,
        };
    })
);
export function reducer(
    state: TeacherMetricsState | undefined,
    action: Action
) {
    return teacherMetricsReducer(state, action);
}

export const getTeacherMetrics = (state: TeacherMetricsState) =>
    state.teacherMetrics;
export const getTeacherMetricsLoading = (state: TeacherMetricsState) =>
    state.loading;
export const getTeacherMetricsLoaded = (state: TeacherMetricsState) =>
    state.loaded;
